import {cn} from "@/shadcn/lib/utils";

interface VariantSkeletonGridProps {
    count?: number;
    className?: string;
    disableAnimation?: boolean;
}

/**
 * Server Component - CSS-only responsive skeleton grid
 * Uses Tailwind grid for responsive layout without JavaScript
 */
export const VariantSkeletonGrid = ({count = 24, className = "", disableAnimation = false}: VariantSkeletonGridProps) => {
    return (
        <div className={`w-full ${className}`}>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-1">
                {Array.from({length: count}).map((_, i) => (
                    <div key={i} className="p-0.5">
                        <div
                            className={cn(
                                "w-full aspect-[1/1.4] rounded-lg bg-slate-100 dark:bg-slate-800",
                                !disableAnimation && "animate-pulse"
                            )}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

/**
 * Single variant skeleton for individual loading states
 */
export const VariantSkeleton = ({disableAnimation = false}: {disableAnimation?: boolean}) => {
    return (
        <div className="p-0.5">
            <div
                className={cn(
                    "w-full aspect-[1/1.4] rounded-lg bg-slate-100 dark:bg-slate-800",
                    !disableAnimation && "animate-pulse"
                )}
            />
        </div>
    );
};
